import { ImageViewer } from '@stormwater-software/lib-ui';
import React, { useContext, useMemo, useState } from 'react';
import { Context as InteractionContext } from '../InteractionContext';

/** A map finding's photos in the full-screen viewer, opened from its overlay's thumbnails. */
export default function MapImageModal() {
  const ic = useContext(InteractionContext);
  const { images, index } = ic.modeData.props;
  const [currentIndex, setCurrentIndex] = useState(index);

  const viewerImages = useMemo(
    () =>
      images.map((image) => ({
        src: image.imageURL,
        annotations: image.annotations || [],
      })),
    [images],
  );

  return (
    <ImageViewer
      images={viewerImages}
      index={currentIndex}
      onIndexChange={setCurrentIndex}
      onClose={() => ic.setDefaultMode()}
      title={images[currentIndex]?.imageName}
    />
  );
}
